export var DataHooks;
(function (DataHooks) {
    DataHooks["currentPage"] = "current-page";
    DataHooks["totalPages"] = "total-pages";
    DataHooks["slashLabel"] = "slash-label";
    DataHooks["pageCompact"] = "page-compact";
    DataHooks["pageForm"] = "page-form";
    DataHooks["pageStrip"] = "page-strip";
    DataHooks["pageInput"] = "page-input";
    DataHooks["previous"] = "previous";
    DataHooks["next"] = "next";
    DataHooks["first"] = "first";
    DataHooks["last"] = "last";
    DataHooks["page"] = "page";
})(DataHooks || (DataHooks = {}));
//# sourceMappingURL=constants.js.map